import Constants from '@/constants/const';
import { PageNameV2 } from '@/constants/track';
import { getPageEventNameV2 } from '@/utils/common/pageKey';
import { setLanguageToFrontend } from '@/utils/common/user';
import { deleteCookie, getCookie, setCookie } from '@/utils/cookie';
import { getPathName } from '@/utils/url';

/**
 * 在用户注册、登录之后给他自动登录然后写入cookie
 * @param token AUTH_TOKEN
 * @param language language
 */
export const afterUserRegisterLogin = (token, language) => {
  if (token) {
    setCookie(
      Constants?.AUTH_TOKEN,
      token,
      {},
      {
        maxAge: Constants.AUTH_TOKEN_EXPIRED_TIME
      }
    );
    setCookie(Constants.IS_LOGIN, '1', {}, { maxAge: Constants.AUTH_TOKEN_EXPIRED_TIME });
  }
  if (language) {
    const lang = getCookie(Constants.LANGUAGE);
    if (setLanguageToFrontend(language) !== lang) {
      deleteCookie(Constants.STORE_INFO);
      deleteCookie(Constants.WEEE_STORE);
    }
    setCookie(
      Constants.LANGUAGE,
      setLanguageToFrontend(language),
      {},
      {
        maxAge: Constants.LANGUAGE_EXPIRED_TIME
      }
    );
  }
};

/**
 * 用户在注册之后所需要做的通用记录操作
 */
export const afterUserSign = (method: string, ctx?) => {
  setCookie(Constants.REGISTRATION_SUCCESS, '1', ctx);
  setCookie(Constants.SUCCESS_METHOD, method, ctx);
  localStorage.setItem('hasSignedUp', '1');
};

/**
 * 用户在注册之后所需要做的通用记录操作
 */
export const afterUserLogin = (method: string, ctx?) => {
  setCookie(Constants.LOGIN_SUCCESS, '1', ctx);
  setCookie(Constants.SUCCESS_METHOD, method, ctx);
};

/**
 * 用户从首页、account跳转登录页面，在登录成功之后，如果接口返回值有next_url，需要跳转next_url，否则保持原逻辑
 * @param nextUrl 需要跳的页面
 * @param fromPage 跳转登录之前的页面
 */
export const afterUserLoginToOnboarding = (nextUrl, fromPageUrl) => {
  return new Promise(resolve => {
    if (!!nextUrl) {
      // url可能带host信息，也可能只是pathname
      const url = decodeURIComponent(fromPageUrl);
      // 获取不带语言位的pathname，匹配路由，返回pageKey
      const pageKey = getPageEventNameV2(getPathName(url));
      const pageKeyList = [PageNameV2.mweb_home, PageNameV2.mweb_me];
      if (pageKeyList.includes(pageKey)) {
        window.location.href = nextUrl;
        return;
      }
    }
    resolve(true);
  });
};
